/* eslint-disable jsx-a11y/img-redundant-alt */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import DialogTitle from './DialogTitle';

const useStyles = makeStyles(() => ({
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  w100: {
    width: '100%',
  },
}));

const ImageModal = ({
  title = '',
  imageSource,
  setImageSource,
  handleDelete,
}) => {
  const classes = useStyles();

  const handleImageClose = () => {
    setImageSource(null);
  };

  return (
    <Dialog
      className={classes.flexCenter}
      open={imageSource}
      onClose={handleImageClose}
    >
      <DialogTitle onClose={handleImageClose}>{title}</DialogTitle>
      <DialogContent>
        <img src={imageSource} alt="Enlarged photo" className={classes.w100} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDelete} color="primary">
          Delete
        </Button>
        <Button onClick={handleImageClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImageModal;
